const messages = {
  title: "Prislistor och produktbroschyrer",
  title_media: "Prislistor och produktbroschyrer",
  description:
    "Ladda ner de senaste broschyrerna och flygbladen om våra Bridgestone- och Firestone-däck för personbilar, SUV och lätta transportbilar.",
  short_description:
    "Här hittar du material för sociala medier, in-store-TV och mer.",
  mediaCategories: {
    products: "Produkter",
    brand_and_solutions: "Varumärke och lösningar",
    season_and_promotions: "Säsong och kampanjer",
    format: "Format",
    cars_and_vans: "Personbil, SUV, lätt lastbil",
    truck_and_buses: "Lastbil och buss",
    motorcycle: "Motorcykel",
    agriculture: "Lantbruk",
    construction_machinery: "Entreprenadmaskiner",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Material",
    brochures: "Produktbroschyrer",
    price_list: "Prislistor",
    materials: "Material",
    video_in_store: "Video med undertexter",
    video_online: "Video utan undertexter",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Sociala medier",
    logos: "Logotyper",
    summer: "Sommar",
    winter: "Vinter",
    all_season: "Helår",
    promotions: "Kampanjer",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIABIBLIOTEK",
    description:
      "Välkommen till mediaavdelningen för   \n" +
      "Bridgestone och Firestone produkter.  \n <br> <br>" +
      "Du kommer att upptäcka produktvisualiseringar,   \n" +
      "logotyper, samt ett brett urval av   \n" +
      "banners, videor och digitala material   \n" +
      "att använda på din webbplats eller på   \n" +
      "sociala medier.  ",
    bDrive: {
      title: "Produktfoton",
      description:
        "Aktuella bilder   \n" +
        "kan laddas ner   \n" +
        "från vår B-\n" +
        "DRIVE portal.  ",
    },
  },
  buttons: {
    media: "UPPTÄCK",
  },
  searchMedia: "Ange sökord",
  searchResults: "Sökresultat",
};

export default {
  messages,
};
